import Link from 'next/link';
import Logo from '../Logo';
import { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

const NAV = [
  {
    title: 'about', href: 'about'
  },
  {
    title: 'products', href: 'products',
    submenu: [{
      title: 'Vector Accelerator C++ Library',
      href: 'vector-mc-accelerator'
    }, {
      title: 'Parallel AAD-C C++ Library',
      href: 'parallel-addc-lib'
    }]
  },
  {
    title: 'solutions', href: 'solutions'
  },
  {
    title: 'research', href: 'research'
  },
  {
    title: 'contact us', href: 'contact'
  }

];

export default class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      navOpen: false,
    };

    this.onNavToggled = this.onNavToggled.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
  }

  handleClickOutside(event) {
    const domNode = ReactDOM.findDOMNode(this);

    if (!domNode || !domNode.contains(event.target)) {
      this.props.onToggle(false);

      this.setState({
        navOpen: false
      });
    }
  }

  onNavToggled() {
    const { navOpen } = this.state;

    this.props.onToggle(!navOpen);

    this.setState({ navOpen: !navOpen });
  }

  render() {
    return (
      <header className="header">
        <button onClick={this.onNavToggled} id="mobile-nav-toggle">
          <i className="lnr lnr-menu"></i>
        </button>
        <div className={`header__nav_mobile ${this.state.navOpen ? 'open' : ''}`}>
          <ul>
            {
              NAV.map((item, i) => (
                <li key={i}>
                  <Link href={"/" + item.href}>
                    <a>{item.title}</a>
                  </Link>
                  {!!item.submenu && (
                    <ul className="header__submenu">
                      {
                        item.submenu.map((subitem, key) => (
                          <li key={key}>
                            <Link href={"/" + subitem.href}>
                              <a>{subitem.title}</a>
                            </Link>
                          </li>
                        ))
                      }
                    </ul>
                  )}
                </li>
              ))
            }
          </ul>
        </div>
        <div className="main-menu">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="align-items-center justify-content-between d-flex">
                  <Logo/>

                  <nav id="nav-menu-container">
                    <ul className="nav-menu sf-arrows">
                      {
                        NAV.map((item, i) => (
                          <li key={i} className={item.submenu && "menu-has-children"}>
                            <Link
                              href={"/" + item.href}
                            >
                              <a className={item.submenu && 'sf-with-ul'}>{item.title}</a>
                            </Link>
                            {!!item.submenu && (
                              <ul>
                                {
                                  item.submenu.map((subitem, key) => (
                                    <li key={key}>
                                      <Link href={"/" + subitem.href}>
                                        <a>{subitem.title}</a>
                                      </Link>
                                    </li>
                                  ))
                                }
                              </ul>
                            )}
                          </li>
                        ))
                      }
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    )
  };
};

Header.propTypes = {
 onToggle: PropTypes.func,
};
